import { render, staticRenderFns } from "./ProcessChargesTripsGrid.vue?vue&type=template&id=b189ae82&scoped=true&"
import script from "./ProcessChargesTripsGrid.vue?vue&type=script&lang=js&"
export * from "./ProcessChargesTripsGrid.vue?vue&type=script&lang=js&"
import style0 from "./ProcessChargesTripsGrid.vue?vue&type=style&index=0&id=b189ae82&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b189ae82",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Kevin\\Documents\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b189ae82')) {
      api.createRecord('b189ae82', component.options)
    } else {
      api.reload('b189ae82', component.options)
    }
    module.hot.accept("./ProcessChargesTripsGrid.vue?vue&type=template&id=b189ae82&scoped=true&", function () {
      api.rerender('b189ae82', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ProcessChargesTrips/ProcessChargesTripsGrid.vue"
export default component.exports